import * as XLSX from 'xlsx';

export const PROJECT_EXCEL_COLUMNS = [
    // Step 1: Basic Info & Media
    { header: 'Project Name*', key: 'name' },
    { header: 'Media Folder Number', key: 'mediaFolderNumber' },
    { header: 'Listing Type', key: 'listingType' },
    { header: 'Property Type', key: 'propertyType' },
    { header: 'Sub Category', key: 'subCategory' },
    { header: 'Project Status*', key: 'projectStatus' },

    // Step 2: Location
    { header: 'City*', key: 'city' },
    { header: 'Locality*', key: 'location' },
    { header: 'Full Address', key: 'address' },
    { header: 'State', key: 'state' },
    { header: 'Pin Code', key: 'pinCode' },
    { header: 'Country', key: 'country' },
    { header: 'Latitude', key: 'latitude' },
    { header: 'Longitude', key: 'longitude' },
    { header: 'Google Map Link', key: 'googleMapLocation' },
    { header: 'Google 3D View Link', key: 'google3dViewLink' },

    // Step 3: Developer + Overview
    { header: 'Builder Name', key: 'developerName' },
    { header: 'Co-Developer', key: 'coDeveloper' },
    { header: 'Developer Description', key: 'developerDescription' },
    { header: 'Established Since', key: 'projectsSince' },
    { header: 'Total Projects', key: 'totalProjects' },
    { header: 'Completed Projects', key: 'projectsCompleted' },
    { header: 'Ongoing Projects', key: 'projectsOngoing' },
    { header: 'Upcoming Projects', key: 'projectsUpcoming' },
    { header: 'Configuration*', key: 'overviewConfiguration' },
    { header: 'Total Plot Area*', key: 'overviewTotalPlotArea' },
    { header: 'Total Amenities*', key: 'overviewAmenitiesIcon' },

    { header: 'Avg Price Per Sqft*', key: 'overviewAvgPricePerSqFt' },
    { header: 'Open Space Percentage*', key: 'overviewOpenSpacePercentage' },
    { header: 'Towers*', key: 'overviewTotalTowers' },
    { header: 'Floors*', key: 'overviewTotalFloors' },
    { header: 'Structure Setup*', key: 'overviewFloors' },
    { header: 'Total Units*', key: 'overviewTotalUnits' },
    { header: 'Completion Progress*', key: 'progressPercentage' },
    { header: 'RERA Registration No.*', key: 'reraNumber' },
    { header: 'Bathrooms*', key: 'overviewBathrooms' },
    { header: 'Age of Construction*', key: 'overviewAgeOfConstruction' },
    { header: 'Parking*', key: 'overviewParking' },

    // Step 4: Floor Architecture
    { header: 'Floor Variant Type A', key: 'floorVariantA' },
    { header: 'Floor Variant Type B', key: 'floorVariantB' },
    { header: 'Floor Variant Type C', key: 'floorVariantC' },
    { header: 'Floor Variant Type D', key: 'floorVariantD' },
    { header: 'Floor Variant Type E', key: 'floorVariantE' },
    { header: 'Area Range', key: 'overviewSizeRange' },

    // Step 5: Pricing + Timeline
    { header: 'Starting Price*', key: 'overviewPriceRange' },
    { header: 'Launch Date', key: 'launchDate' },
    { header: 'Possession Date', key: 'possessionDate' },
    { header: 'Project Phase', key: 'projectPhase' },

    // Step 6: Content
    { header: 'Short Description', key: 'shortDescription' },
    { header: 'Full Project Overview', key: 'fullDescription' },

    // Step 11: SEO
    { header: 'Meta Title', key: 'metaTitle' },
    { header: 'SEO Keywords', key: 'metaKeywords' },
    { header: 'Meta Description', key: 'metaDescription' },
    { header: 'Focus Keyword', key: 'focusKeyword' },
    
    // Step 8: Content & Details
    { header: 'Key Highlights', key: 'highlights' },
    { header: 'Nearby Landmarks', key: 'nearbyPlaces' },
    { header: 'Amenities', key: 'amenities' },
    { header: 'Specifications', key: 'specifications' },
    { header: 'FAQ', key: 'faq' },
    { header: 'Disclaimer', key: 'disclaimer' },
    { header: 'Video URL', key: 'videoUrl' },
    { header: 'Project Brochure', key: 'brochureUrl' },
];

export const generateSampleExcel = () => {
    const headers = PROJECT_EXCEL_COLUMNS.map(col => col.header);
    const sampleData = [
        [
            'Premium Heights', // Project Name
            '1', // Media Folder Number (Folder 1: Cover, Floor variants, Gallery, Docs)
            'For Sale', // Listing Type
            'Residential', // Property Type
            'Flat/Apartment', // Sub Category
            'Under Construction', // Project Status
            'Ahmedabad', // City
            'SG Highway', // Locality
            'Near Iscon Mall, SG Highway, Ahmedabad', // Address
            'Gujarat', // State
            '380015', // Pin Code
            'India', // Country
            '23.0225', // Latitude
            '72.5714', // Longitude
            'https://maps.google.com/?q=23.0225,72.5714', // Google Map Link
            'https://earth.google.com/web/...', // Google 3D View Link
            'Property Guru Developers', // Builder Name
            'Co-Builder Group', // Co-Developer
            'We are the best developers in the city.', // Developer Description
            '2005', // Established Since
            '50', // Total Projects
            '45', // Completed Projects
            '12', // Ongoing Projects
            '5', // Upcoming Projects
            '2, 3 BHK', // Configuration
            '5.5 Acres', // Total Plot Area
            '30+ Premium Amenities', // Total Amenities
            '5500', // Avg Price Per Sqft
            '65%', // Open Space Percentage
            '6', // Towers
            '14', // Floors
            'Basement + G + 14', // Structure Setup
            '420', // Total Units
            '65', // Completion Progress
            'PR/GJ/AHMEDABAD/AUDA/RAA123456/010124', // RERA Registration No.
            '3', // Bathrooms
            '0-5 Years', // Age of Construction
            '1 Covered, 1 Open', // Parking
            '2BHK Standard', // Floor Variant Type A
            '2BHK Luxury', // Floor Variant Type B
            '3BHK Premium', // Floor Variant Type C
            '3BHK Ultra', // Floor Variant Type D
            '4BHK Penthouse', // Floor Variant Type E
            '1050 - 1850 Sq.Ft.', // Area Range
            '85L - 1.2Cr', // Starting Price
            '2024-01-01', // Launch Date
            '2026-12-31', // Possession Date
            'Under Construction', // Project Phase
            'Experience luxury with Premium Heights.', // Short Description
            'Premium Heights offers a unique blend of modern architecture and natural surroundings...', // Full Project Overview
            'Premium Heights | Luxury Apartments in Ahmedabad', // Meta Title
            'Luxury apartments, Ahmedabad real estate, 2BHK 3BHK flats', // SEO Keywords
            'Discover the finest luxury apartments in Ahmedabad at Premium Heights.', // Meta Description
            'luxury apartments ahmedabad', // Focus Keyword
            'Prime Location | Premium Residences | 65% Open Space', // Highlights
            'Delhi Public School,2.5,Schools | Apollo Hospital,4.0,Hospitals', // Nearby Landmarks
            'Swimming Pool, Gymnasium, Club House, 24x7 Security', // Amenities
            'Flooring:Vitrified tiles | Kitchen:Granite platform with stainless steel sink', // Specifications
            'What is the expected possession date?:December 2026 | Are home loans available?:Yes with SBI and HDFC', // FAQ
            'All layouts, plans, specifications, dimensions, designs, measurements and locations are indicative.', // Disclaimer
            'https://youtube.com/watch?v=sample', // Video URL
            'https://mypropertyguru.in/uploads/media-folders/1/documents/sample-project-brochure.pdf' // Project Brochure
        ],
        [
            'Grand Royal Residency', // Project Name
            '2', // Media Folder Number
            'For Sale',
            'Residential',
            'Villa',
            'Ready to Move',
            'Ahmedabad',
            'Bopal',
            'Near Bopal Lake, Ahmedabad',
            'Gujarat',
            '380058',
            'India',
            '23.0335',
            '72.4632',
            'https://maps.google.com/?q=23.0335,72.4632',
            '',
            'Property Guru Developers',
            '',
            'Leading villa developers.',
            '2010',
            '25',
            '20',
            '4',
            '1',
            '4, 5 BHK',
            '12 Acres',
            '25+ Amenities',
            '7200',
            '70%',
            '0',
            '2',
            'G + 1',
            '60',
            '100',
            'PR/GJ/AHMEDABAD/AUDA/RAA987654/010124',
            '5',
            '0-1 Year',
            '2 Covered',
            '4BHK Luxury Villa',
            '5BHK Royal Villa',
            '',
            '',
            '',
            '2500 - 4200 Sq.Ft.',
            '1.8Cr - 3.5Cr',
            '2023-01-01',
            '2025-06-30',
            'Ready to Move',
            'Exclusive luxury villas in Bopal.',
            'Grand Royal Residency is an exclusive gated community of luxury villas...',
            'Grand Royal Residency | Luxury Villas in Bopal Ahmedabad',
            'Villas in Ahmedabad, Luxury homes, Bopal villas',
            'Explore ultra-luxury villas at Grand Royal Residency Bopal.',
            'villas in bopal ahmedabad',
            'Private Garden | Personal Pool Option | Gated Community',
            'Club O7,1.2,Entertainment | South Bopal Cross Road,2.0,Transit',
            'Private Garden, Club House, 24x7 Security, Badminton Court',
            'Structure:RCC framed earthquake resistant | Flooring:Italian marble in living',
            'Is the project ready?:Yes ready for possession | Loan approval?:Approved by all major banks',
            'All layouts and renderings are indicative.',
            'https://youtube.com/watch?v=sample2',
            'https://mypropertyguru.in/uploads/media-folders/1/documents/sample-project-brochure.pdf'
        ]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
    // Set auto-width for all columns
    worksheet['!cols'] = headers.map(h => ({ wch: Math.max(h.length + 4, 18) }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Projects');

    // Instructions Sheet
    const instructionRows = [
        ['MY PROPERTY GURU - PROJECT IMPORT EXCEL GUIDE & INSTRUCTIONS'],
        [''],
        ['COLUMN NAME', 'HOW TO FILL', 'EXAMPLE VALUE', 'NOTES'],
        ['Project Name*', 'Required project title', 'Premium Heights', 'Mandatory field'],
        ['Media Folder Number', 'Folder number from Admin > Media Folders', '1', 'Auto-loads Cover Photo, 2D/3D Floor Plans, Gallery Photos, Brochure, Legal Documents'],
        ['Listing Type', 'For Sale / For Rent / Both', 'For Sale', 'Defaults to For Sale'],
        ['Property Type', 'Residential / Commercial', 'Residential', 'Defaults to Residential'],
        ['Sub Category', 'Flat/Apartment, Villa, Plot, Office, etc.', 'Flat/Apartment', ''],
        ['Project Status*', 'Under Construction / Ready to Move / Newly Launched', 'Under Construction', 'Mandatory field'],
        ['City*', 'City name', 'Ahmedabad', 'Mandatory field'],
        ['Locality*', 'Area / Locality name', 'SG Highway', 'Mandatory field'],
        ['Starting Price*', 'Price string or range', '85L - 1.2Cr', 'Mandatory field'],
        ['Configuration*', 'Apartment configuration', '2, 3 BHK', 'Mandatory field'],
        ['Total Plot Area*', 'Size with unit', '5.5 Acres', 'Mandatory field'],
        ['Floor Variant Type A - E', 'Variant names', '2BHK Luxury', 'Optional: Floor plans are auto-assigned if Media Folder is provided'],
        ['Key Highlights', 'Pipe separated text', 'Prime Location | 65% Open Space', 'Use | separator'],
        ['Nearby Landmarks', 'Format: Name,DistanceInKm,Category | ...', 'DPS,2.5,Schools | Apollo Hospital,4.0,Hospitals', 'Pipe and comma separated'],
        ['Amenities', 'Comma separated names', 'Swimming Pool, Gymnasium, Club House', 'Matches existing amenities in database'],
        ['Specifications', 'Category:Details separated by pipe', 'Flooring:Vitrified tiles | Kitchen:Granite', 'Use : and |'],
        ['FAQ', 'Question:Answer separated by pipe', 'What is possession date?:Dec 2026', 'Use : and |'],
        ['Project Brochure', 'Direct link to PDF brochure', 'https://mypropertyguru.in/uploads/sample-brochure.pdf', 'Optional: Paste direct URL/link to the project brochure PDF file'],
        [''],
        ['TIP: Upload your project photos in Admin > Media Folders (http://localhost:3000/admin-media), note the Folder Number (e.g. 1, 2) and enter it in "Media Folder Number" column. All media is auto-assigned!']
    ];
    const instructionSheet = XLSX.utils.aoa_to_sheet(instructionRows);
    instructionSheet['!cols'] = [{ wch: 25 }, { wch: 45 }, { wch: 35 }, { wch: 70 }];
    XLSX.utils.book_append_sheet(workbook, instructionSheet, 'Instructions & Guide');

    // Create binary string
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'project_import_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseProjectExcel = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const targetSheet = workbook.SheetNames.includes('Projects') ? 'Projects' : workbook.SheetNames[0];
                const worksheet = workbook.Sheets[targetSheet];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                // Map headers back to keys
                const mappedData = jsonData.map((row: any) => {
                    const mappedRow: any = {};
                    const rowKeys = Object.keys(row);
                    
                    PROJECT_EXCEL_COLUMNS.forEach(col => {
                        // Find a row key that matches the column header (trimmed and without asterisk)
                        const cleanHeader = col.header.replace(/\*/g, '').trim().toLowerCase();
                        const matchingKey = rowKeys.find(key => {
                            const cleanKey = key.replace(/\*/g, '').trim().toLowerCase();
                            if (cleanKey === cleanHeader) return true;
                            
                            // Flexible matches for common variations
                            if (cleanHeader === 'builder name' && (cleanKey === 'developer name' || cleanKey === 'developer' || cleanKey === 'builder')) return true;
                            if (cleanHeader === 'project status' && (cleanKey === 'status' || cleanKey === 'projectstatus' || cleanKey === 'construction status')) return true;
                            if (cleanHeader === 'project phase' && cleanKey === 'phase') return true;
                            if (cleanHeader === 'total plot area' && (cleanKey === 'size' || cleanKey === 'area' || cleanKey === 'project area' || cleanKey === 'plot area')) return true;
                            if (cleanHeader === 'area range' && (cleanKey === 'size range' || cleanKey === 'unit size')) return true;
                            if (cleanHeader === 'completion progress' && (cleanKey === 'progress' || cleanKey === 'completion' || cleanKey === 'percentage')) return true;
                            if (cleanHeader === 'rera registration no' && (cleanKey === 'rera registration no' || cleanKey === 'rera approved' || cleanKey === 'rera number' || cleanKey === 'rera')) return true;
                            
                            // Step 8 fields
                            if (cleanHeader === 'key highlights' && cleanKey.includes('highlight')) return true;
                            if (cleanHeader === 'nearby landmarks' && cleanKey.includes('landmark')) return true;
                            if (cleanHeader === 'amenities' && cleanKey.includes('amenit') && !cleanKey.includes('total')) return true;
                            if (cleanHeader === 'specifications' && cleanKey.includes('specific')) return true;
                            if (cleanHeader === 'faq' && cleanKey.includes('faq')) return true;
                            if (cleanHeader === 'disclaimer' && cleanKey.includes('disclaimer')) return true;
                            if (cleanHeader === 'project brochure' && (
                                cleanKey === 'project brochure' ||
                                cleanKey === 'brochure' ||
                                cleanKey === 'brochure url' ||
                                cleanKey === 'brochure link' ||
                                cleanKey === 'project brochure link' ||
                                cleanKey.includes('brochure')
                            )) return true;

                            // Media folder number flexible match
                            if (cleanHeader === 'media folder number') {
                                const clean = cleanKey.replace(/[^a-z0-9]/g, '');
                                if (
                                    clean === 'mediafoldernumber' ||
                                    clean === 'mediafolder' ||
                                    clean === 'mediafolderno' ||
                                    clean === 'foldernumber' ||
                                    clean === 'folderno' ||
                                    clean === 'media' ||
                                    clean === 'medianumber' ||
                                    (clean.includes('media') && clean.includes('folder')) ||
                                    (clean.includes('folder') && (clean.includes('no') || clean.includes('num')))
                                ) return true;
                            }
                            
                            return false;
                        });
                        
                        if (matchingKey && row[matchingKey] !== undefined) {
                            if (col.key === 'mediaFolderNumber') {
                                const rawVal = row[matchingKey];
                                if (rawVal !== undefined && rawVal !== null && String(rawVal).trim() !== '') {
                                    const match = String(rawVal).match(/\d+/);
                                    mappedRow[col.key] = match ? parseInt(match[0], 10) : rawVal;
                                }
                            } else {
                                mappedRow[col.key] = row[matchingKey];
                            }
                        }
                    });
                    return mappedRow;
                });
                
                resolve(mappedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

// ... rest of the file (DEVELOPER_EXCEL_COLUMNS etc.)
export const DEVELOPER_EXCEL_COLUMNS = [
    { header: 'Developer Name*', key: 'name' },
    { header: 'Email*', key: 'email' },
    { header: 'Password', key: 'password' },
    { header: 'Phone', key: 'phone' },
    { header: 'City', key: 'city' },
    { header: 'Established Since', key: 'projectsSince' },
    { header: 'Total Projects', key: 'totalProjects' },
    { header: 'Completed Projects', key: 'projectsCompleted' },
    { header: 'Ongoing Projects', key: 'projectsOngoing' },
    { header: 'Upcoming Projects', key: 'projectsUpcoming' },
    { header: 'About/Description', key: 'about' },
    { header: 'Expertise', key: 'expertise' },
];

export const generateDeveloperSampleExcel = () => {
    const headers = DEVELOPER_EXCEL_COLUMNS.map(col => col.header);
    const sampleData = [
        [
            'Property Guru Developers',
            'contact@propertyguru.com',
            '123456',
            '9876543210',
            'Ahmedabad',
            '2005',
            '45',
            '40',
            '3',
            '2',
            'A leading real estate development firm in Gujarat.',
            'Residential, Commercial, Industrial'
        ]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Developers');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'developer_import_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseDeveloperExcel = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                const mappedData = jsonData.map((row: any) => {
                    const mappedRow: any = {};
                    const rowKeys = Object.keys(row);
                    
                    DEVELOPER_EXCEL_COLUMNS.forEach(col => {
                        const cleanHeader = col.header.replace(/\*/g, '').trim().toLowerCase();
                        const matchingKey = rowKeys.find(key => {
                            const cleanKey = key.replace(/\*/g, '').trim().toLowerCase();
                            if (cleanKey === cleanHeader) return true;
                            
                            // Flexible matches
                            if (cleanHeader === 'about/description' && (cleanKey === 'about' || cleanKey === 'description')) return true;
                            if (cleanHeader === 'established since' && (cleanKey === 'since' || cleanKey === 'year')) return true;
                            if (cleanHeader === 'expertise' && cleanKey === 'expertise') return true;
                            
                            return false;
                        });
                        
                        if (matchingKey && row[matchingKey] !== undefined) {
                            mappedRow[col.key] = row[matchingKey];
                        }
                    });
                    return mappedRow;
                });
                
                resolve(mappedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

export const LOCALITY_EXCEL_COLUMNS = [
    { header: 'Locality Name*', key: 'name' },
    { header: 'City Name*', key: 'city' },
    { header: 'Description', key: 'description' },
    { header: 'Avg Price Per SqFt', key: 'avgPricePerSqFt' },
    { header: 'Old Avg Price Per SqFt', key: 'oldAvgPricePerSqFt' },
    { header: 'Growth Percentage', key: 'growthPercentage' },
    { header: 'Growth Score (0.5 to 2)', key: 'growthScore' },
    { header: 'Is Active (true/false)', key: 'isActive' },
];

export const generateLocalitySampleExcel = () => {
    const headers = LOCALITY_EXCEL_COLUMNS.map(col => col.header);
    const sampleData = [
        [
            'Gota',
            'Ahmedabad',
            'A developing residential locality in the northern part of Ahmedabad.',
            '4500',
            '4200',
            '7.14',
            '1.5',
            'true'
        ],
        [
            'Whitefield',
            'Bangalore',
            'A major IT hub and residential suburb in Eastern Bangalore.',
            '8500',
            '7800',
            '8.97',
            '1.8',
            'true'
        ]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Localities');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'locality_import_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseLocalityExcel = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                const mappedData = jsonData.map((row: any) => {
                    const mappedRow: any = {};
                    const rowKeys = Object.keys(row);
                    
                    LOCALITY_EXCEL_COLUMNS.forEach(col => {
                        const cleanHeader = col.header.replace(/\*/g, '').trim().toLowerCase();
                        const matchingKey = rowKeys.find(key => {
                            const cleanKey = key.replace(/\*/g, '').trim().toLowerCase();
                            if (cleanKey === cleanHeader) return true;
                            return false;
                        });
                        
                        if (matchingKey && row[matchingKey] !== undefined) {
                            mappedRow[col.key] = row[matchingKey];
                        }
                    });
                    return mappedRow;
                });
                
                resolve(mappedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

export const LANDMARK_EXCEL_COLUMNS = [
    { header: 'Landmark Name*', key: 'name' },
    { header: 'Category Name*', key: 'categoryName' },
    { header: 'Distance (KM)*', key: 'km' },
];

export const generateLandmarkSampleExcel = () => {
    const headers = LANDMARK_EXCEL_COLUMNS.map(col => col.header);
    const sampleData = [
        [
            'Grand Central Mall',
            'Shopping Malls',
            '1.5'
        ],
        [
            'City Hospital',
            'Hospitals',
            '2.3'
        ],
        [
            'Metro Station',
            'Bus Stops',
            '0.8'
        ]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Landmarks');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'landmark_import_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseLandmarkExcel = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                const mappedData = jsonData.map((row: any) => {
                    const mappedRow: any = {};
                    const rowKeys = Object.keys(row);
                    
                    LANDMARK_EXCEL_COLUMNS.forEach(col => {
                        const cleanHeader = col.header.replace(/\*/g, '').trim().toLowerCase();
                        const matchingKey = rowKeys.find(key => {
                            const cleanKey = key.replace(/\*/g, '').trim().toLowerCase();
                            if (cleanKey === cleanHeader) return true;
                            
                            // fallback flexible matches
                            if (cleanHeader === 'landmark name' && (cleanKey === 'name' || cleanKey === 'landmark')) return true;
                            if (cleanHeader === 'category name' && (cleanKey === 'category' || cleanKey === 'landmark category')) return true;
                            if (cleanHeader === 'distance (km)' && (cleanKey === 'km' || cleanKey === 'distance')) return true;
                            return false;
                        });
                        
                        if (matchingKey && row[matchingKey] !== undefined) {
                            mappedRow[col.key] = row[matchingKey];
                        }
                    });
                    return mappedRow;
                });
                
                resolve(mappedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

export const FLOORPLAN_EXCEL_COLUMNS = [
    { header: 'Unit Type*', key: 'unitType' },
    { header: 'Sub Unit Type', key: 'subUnitType' },
    { header: 'Variant Name*', key: 'subUnitVariant' },
    { header: 'Starting Price*', key: 'price' },
    { header: 'Facing*', key: 'facing' },
    { header: 'RERA Carpet*', key: 'carpetArea' },
    { header: 'RERA Area', key: 'reraArea' },
    { header: 'Built-up*', key: 'builtUpArea' },
    { header: 'Super B-up*', key: 'superBuiltUpArea' },
    { header: 'Features', key: 'details' }
];

export const generateFloorPlanSampleExcel = () => {
    const headers = FLOORPLAN_EXCEL_COLUMNS.map(col => col.header);
    const sampleData = [
        [
            '2 BHK Premium',
            'Residential',
            'Type A',
            '85 L',
            'East, North',
            '1050',
            '1100',
            '1250',
            '1400',
            'Balcony:Yes, Master Bedroom:12x14, Kitchen:Modular'
        ],
        [
            '3 BHK Elite',
            'Residential',
            'Type B',
            '1.25 Cr',
            'West, East',
            '1450',
            '1500',
            '1700',
            '1900',
            'Balcony:2, Master Bedroom:14x16, Wardrobes:Included'
        ]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FloorPlans');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'floorplan_import_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseFloorPlanExcel = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                const mappedData = jsonData.map((row: any) => {
                    const mappedRow: any = {};
                    const rowKeys = Object.keys(row);
                    
                    FLOORPLAN_EXCEL_COLUMNS.forEach(col => {
                        const cleanHeader = col.header.replace(/\*/g, '').trim().toLowerCase();
                        const matchingKey = rowKeys.find(key => {
                            const cleanKey = key.replace(/\*/g, '').trim().toLowerCase();
                            if (cleanKey === cleanHeader) return true;
                            return false;
                        });
                        
                        if (matchingKey && row[matchingKey] !== undefined) {
                            mappedRow[col.key] = row[matchingKey];
                        }
                    });
                    return mappedRow;
                });
                
                resolve(mappedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

export const FAQ_EXCEL_COLUMNS = [
    { header: 'Question*', key: 'question' },
    { header: 'Strategic Answer*', key: 'answer' },
    { header: 'Legal Disclosures', key: 'disclaimer' }
];

export const generateFAQSampleExcel = () => {
    const headers = FAQ_EXCEL_COLUMNS.map(col => col.header);
    const sampleData = [
        [
            'How does the payment plan work?',
            'We offer flexible payment structures based on construction milestones.',
            'All transactions are subject to RERA registration guidelines.'
        ],
        [
            'What is the expected possession date?',
            'The expected possession is scheduled for December 2026.',
            'Registration charges and stamp duty extra.'
        ]
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'FAQs');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'faq_import_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseFAQExcel = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                const mappedData = jsonData.map((row: any) => {
                    const mappedRow: any = {};
                    const rowKeys = Object.keys(row);
                    
                    FAQ_EXCEL_COLUMNS.forEach(col => {
                        const cleanHeader = col.header.replace(/\*/g, '').trim().toLowerCase();
                        const matchingKey = rowKeys.find(key => {
                            const cleanKey = key.replace(/\*/g, '').trim().toLowerCase();
                            if (cleanKey === cleanHeader) return true;
                            
                            // fallback flexible matches
                            if (cleanHeader === 'question' && (cleanKey === 'q' || cleanKey === 'faq' || cleanKey === 'questions')) return true;
                            if (cleanHeader === 'strategic answer' && (cleanKey === 'answer' || cleanKey === 'ans' || cleanKey === 'strategic answer' || cleanKey === 'answers')) return true;
                            if (cleanHeader === 'legal disclosures' && (cleanKey === 'legal disclosures' || cleanKey === 'disclaimer' || cleanKey === 'disclosures' || cleanKey === 'legal' || cleanKey === 'disclaimer points')) return true;
                            return false;
                        });
                        
                        if (matchingKey && row[matchingKey] !== undefined) {
                            mappedRow[col.key] = row[matchingKey];
                        }
                    });
                    return mappedRow;
                });
                
                resolve(mappedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

export const CLASSIFIED_PROPERTY_EXCEL_COLUMNS = [
    { header: 'Property Category*', key: 'propertyCategory' },
    { header: 'Sub Category*', key: 'subCategory' },
    { header: 'Property Type*', key: 'propertyType' },
    { header: 'Price*', key: 'price' },
    { header: 'Size*', key: 'size' },
    { header: 'Building Name*', key: 'buildingName' },
    { header: 'Area*', key: 'area' },
    { header: 'City*', key: 'city' },
    { header: 'Occupancy Type', key: 'occupancyType' },
    { header: 'Property Age', key: 'propertyAge' },
    { header: 'Floor', key: 'floor' },
    { header: 'Washrooms', key: 'washrooms' },
    { header: 'BHK Configuration', key: 'bhkConfiguration' },
    { header: 'Furnishing Type', key: 'furnishingType' },
    { header: 'Description*', key: 'description' },
    { header: 'Total Units', key: 'totalUnit' },
    { header: 'Facing', key: 'facing' },
    { header: 'No of Parking', key: 'noOfParking' },
    { header: 'Contact Name', key: 'contactName' },
    { header: 'Contact Number', key: 'contactNumber' },
    { header: 'Contact Email', key: 'contactEmail' },
    { header: 'Posted By', key: 'postedBy' }
];

export const generateClassifiedPropertySampleExcel = () => {
    const headers = CLASSIFIED_PROPERTY_EXCEL_COLUMNS.map(col => col.header);
    const sampleData = [
        [
            'RESIDENTIAL',
            'Flat/Apartment',
            'Residential Rent',
            '25000',
            '1250',
            'Symphony Heights',
            'Satellite',
            'Ahmedabad',
            'Only For Family',
            '1-5 Yrs',
            '4',
            '2',
            '3 BHK',
            'Fully Furnished',
            'Beautiful flat with nice environment.',
            '120',
            'East',
            '1',
            'Amit Shah',
            '9876543210',
            'amit.shah@example.com',
            'Owner'
        ]
];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Properties');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'classified_property_import_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseClassifiedPropertyExcel = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                const mappedData = jsonData.map((row: any) => {
                    const mappedRow: any = {};
                    const rowKeys = Object.keys(row);
                    
                    CLASSIFIED_PROPERTY_EXCEL_COLUMNS.forEach(col => {
                        const cleanHeader = col.header.replace(/\*/g, '').trim().toLowerCase();
                        const matchingKey = rowKeys.find(key => {
                            const cleanKey = key.replace(/\*/g, '').trim().toLowerCase();
                            if (cleanKey === cleanHeader) return true;
                            return false;
                        });
                        
                        if (matchingKey && row[matchingKey] !== undefined) {
                            mappedRow[col.key] = row[matchingKey];
                        }
                    });
                    return mappedRow;
                });
                
                resolve(mappedData);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};
export const generateStep8SampleExcel = () => {
    const workbook = XLSX.utils.book_new();

    const headers = [
        "Key Highlights",
        "Nearby Landmarks",
        "Amenities",
        "Specifications",
        "FAQ",
        "Disclaimer",
        "Legal Documents",
        "Dynamic Slots"
    ];

    const sampleData = [
        [
            "Prime Location | Premium Residences | 65% Open Space",
            "Delhi Public School,2.5,Schools | Apollo Hospital,4.0,Hospitals",
            "Swimming Pool, Gymnasium, Club House, 24x7 Security",
            "Flooring:Vitrified tiles | Kitchen:Granite platform with stainless steel sink",
            "What is the expected possession date?:December 2026 | Are home loans available?:Yes with SBI and HDFC",
            "All layouts, plans, specifications, dimensions, designs, measurements and locations are indicative.",
            "RERA Certificate:https://rera.link",
            "Offer Highlights:HTML Content:<p>Get free modular kitchen</p>"
        ]
    ];

    XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet([headers, ...sampleData]), "Step 8 Data");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    
    const url = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "step8_details_import_template.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const parseStep8Excel = (file: File): Promise<any> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: "array" });
                
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                if (!jsonData || jsonData.length === 0) {
                    return resolve({});
                }

                const row: any = jsonData[0];
                
                // Find correct keys ignoring case
                const rowKeys = Object.keys(row).reduce((acc: any, key) => {
                    acc[key.toLowerCase()] = key;
                    return acc;
                }, {});

                const getVal = (key: string) => row[rowKeys[key.toLowerCase()]] || "";

                const highlightsStr = getVal("key highlights");
                const landmarksStr = getVal("nearby landmarks");
                const amenitiesStr = getVal("amenities");
                const specsStr = getVal("specifications");
                const faqStr = getVal("faq");
                const disclaimerStr = getVal("disclaimer");
                const legalStr = getVal("legal documents");
                const dynamicStr = getVal("dynamic slots");

                const result: any = {
                    highlights: highlightsStr ? String(highlightsStr).split('|').map(h => ({ icon: "fa-star", text: h.trim() })) : [],
                    nearbyPlaces: landmarksStr ? String(landmarksStr).split('|').map(place => {
                        const parts = place.split(',');
                        return { name: parts[0]?.trim() || '', distance: parts[1]?.trim() || '', category: parts[2]?.trim() || 'Landmark' };
                    }) : [],
                    amenities: amenitiesStr ? String(amenitiesStr).split(',').map(a => a.trim()).filter(Boolean) : [],
                    specifications: specsStr ? String(specsStr).split('|').map(spec => {
                        const parts = spec.split(':');
                        return { category: parts[0]?.trim() || '', details: parts.slice(1).join(':').trim() || '', icon: "fa-check" };
                    }) : [],
                    faq: faqStr ? String(faqStr).split('|').map(f => {
                        const parts = f.split(':');
                        return { question: parts[0]?.trim() || '', answer: parts.slice(1).join(':').trim() || '' };
                    }) : [],
                    disclaimer: disclaimerStr || "",
                    legalDocuments: legalStr ? String(legalStr).split('|').map(doc => {
                        const parts = doc.split(':');
                        return { title: parts[0]?.trim() || '', link: parts.slice(1).join(':').trim() || '', imagePreview: '', image: '' };
                    }) : [],
                    dynamicSlots: dynamicStr ? String(dynamicStr).split('|').map(slot => {
                        const parts = slot.split(':');
                        return { title: parts[0]?.trim() || '', contentType: (parts[1]?.trim() as any) || 'HTML Content', content: parts.slice(2).join(':').trim() || '' };
                    }) : [],
                };
                
                resolve(result);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

